// removed by extract-text-webpack-plugin
module.exports = {"container":"src-modules-app-__MainLayout__container--1yeoI","content":"src-modules-app-__MainLayout__content--1RZSM","content-inner":"src-modules-app-__MainLayout__content-inner--ctmEt"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/app/MainLayout.less
// module id = 1879
// module chunks = 0